import { render } from "./equipementEOS.vue?vue&type=template&id=73310628"
import script from "./equipementEOS.vue?vue&type=script&lang=ts"
export * from "./equipementEOS.vue?vue&type=script&lang=ts"
script.render = render

export default script